import { SVGProps, useId } from 'react';

export interface IconWrapperProps extends SVGProps<SVGSVGElement> {
  title?: string;
  decorative?: boolean;
  'data-testid'?: string;
  disableSize?: boolean;
}

const IconWrapper = ({
  title = '',
  decorative = !title,
  width = '24',
  height = width,
  viewBox = '0 0 24 24',
  className,
  children,
  role,
  fill = 'none',
  disableSize = false,
  ref,
  ...rest
}: IconWrapperProps) => {
  const id = useId();
  const titleId = title ? `icon-title-${id}` : undefined;

  const finalWidth = disableSize ? undefined : width;
  const finalHeight = disableSize ? undefined : height;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      width={finalWidth}
      height={finalHeight}
      className={className}
      role={role ?? (decorative ? undefined : 'img')}
      aria-hidden={decorative ? true : undefined}
      aria-labelledby={titleId}
      suppressHydrationWarning
      fill={fill}
      id={rest.id}
      tabIndex={rest.tabIndex}
      stroke={rest.stroke}
      strokeWidth={rest.strokeWidth}
      strokeLinecap={rest.strokeLinecap}
      strokeLinejoin={rest.strokeLinejoin}
      strokeDasharray={rest.strokeDasharray}
      strokeDashoffset={rest.strokeDashoffset}
      style={rest.style}
      onClick={rest.onClick}
      onMouseEnter={rest.onMouseEnter}
      onMouseLeave={rest.onMouseLeave}
      onFocus={rest.onFocus}
      onBlur={rest.onBlur}
      data-testid={rest['data-testid']}
      aria-label={rest['aria-label']}
    >
      {title && (
        <title id={titleId} suppressHydrationWarning>
          {title}
        </title>
      )}
      {children}
    </svg>
  );
};

IconWrapper.displayName = 'IconWrapper';
export default IconWrapper;
